var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainWrapper", attrs: { id: "top" } },
    [
      _c("head-nav", { attrs: { gray: _vm.gray } }),
      _vm._v(" "),
      _c("div", { staticClass: "innerWrapper" }, [
        _c("h1", [
          _vm._v("\n      Your account\n      "),
          _c("button", { on: { click: _vm.logout } }, [_vm._v("Log out")])
        ]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "\n      This section allows you to view your account details,\n      " +
              _vm._s(_vm.bonusText) +
              " the amount of commissions to receive, your financial\n      year income, access your invoices and properties that you have\n      bookmarked, reserved and purchased.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detailWrapper" }, [
        _c("div", { staticClass: "inn" }, [
          _c("h1", { class: "tenant-" + _vm.tenant }, [_vm._v("Your details")]),
          _vm._v(" "),
          _c("p", { staticClass: "clear", staticStyle: { display: "flex" } }, [
            _c("span", { staticStyle: { width: "3rem" } }, [
              _vm._v("Company name:")
            ]),
            _c("i", [_vm._v(_vm._s(_vm.user.companyName))])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "clear", staticStyle: { display: "flex" } }, [
            _c("span", { staticStyle: { width: "3rem" } }, [_vm._v("Name:")]),
            _c("i", [
              _vm._v(
                _vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName)
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "clear", staticStyle: { display: "flex" } }, [
            _c("span", { staticStyle: { width: "3rem" } }, [
              _vm._v("Address:")
            ]),
            _c("i", [
              _vm._v(
                _vm._s(_vm.user.address) +
                  ", " +
                  _vm._s(_vm.user.suburb) +
                  ", " +
                  _vm._s(_vm.user.state) +
                  ",\n          " +
                  _vm._s(_vm.user.postcode)
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "clear", staticStyle: { display: "flex" } }, [
            _c("span", { staticStyle: { width: "3rem" } }, [
              _vm._v("Phone number:")
            ]),
            _c("i", [_vm._v(_vm._s(_vm.user.phoneNumber))])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "clear", staticStyle: { display: "flex" } }, [
            _c("span", { staticStyle: { width: "3rem" } }, [_vm._v("Mobile:")]),
            _c("i", [_vm._v(_vm._s(_vm.user.mobileNumber))])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "clear", staticStyle: { display: "flex" } }, [
            _c("span", { staticStyle: { width: "3rem" } }, [_vm._v("Email:")]),
            _c("i", [_vm._v(_vm._s(_vm.user.email))])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "clear", staticStyle: { display: "flex" } }, [
            _c("span", { staticStyle: { width: "3rem" } }, [
              _vm._v("C/C email:")
            ]),
            _c("i", [_vm._v(_vm._s(_vm.user.ccEmail))])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "clear", staticStyle: { display: "flex" } }, [
            _c("span", { staticStyle: { width: "3rem" } }, [
              _vm._v("ABN or ACN:")
            ]),
            _c("i", [_vm._v(_vm._s(_vm.user.abn))])
          ]),
          _vm._v(" "),
          _c("button", { on: { click: _vm.edit } }, [_vm._v("Edit details")])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "otherWrapper" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false"
                }
              ],
              staticClass: "banner"
            },
            [
              _vm.sold.needSales > 0
                ? _c("h3", [
                    _vm._v("\n        You're at "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.sold.alreadySales) + " out of 5")
                    ]),
                    _vm._v(
                      " sales for\n        " + _vm._s(_vm.month) + "!\n      "
                    )
                  ])
                : _c("h3", [
                    _vm._v("Congratulations, you've earned the UNIFI bonus!")
                  ]),
              _vm._v(" "),
              _c("i", { staticClass: "lt" }),
              _vm._v(" "),
              _c("i", { staticClass: "lb" }),
              _vm._v(" "),
              _c("i", { staticClass: "rt" }),
              _vm._v(" "),
              _c("i", { staticClass: "rb" }),
              _vm._v(" "),
              _c("div", { staticClass: "icons" }, [
                _vm.sold.alreadySales > 4
                  ? _c(
                      "div",
                      { staticClass: "icon clear" },
                      _vm._l(_vm.sold.iconList, function(icon, index) {
                        return _c("div", {
                          key: index,
                          staticClass: "i yellow"
                        })
                      }),
                      0
                    )
                  : _c(
                      "div",
                      { staticClass: "icon clear" },
                      _vm._l(_vm.sold.iconList, function(icon, index) {
                        return _c("div", {
                          key: index,
                          staticClass: "i",
                          class: {
                            white: icon.status == "sold",
                            hyline: icon.status == "need"
                          }
                        })
                      }),
                      0
                    )
              ]),
              _vm._v(" "),
              _vm.sold.needSales > 0
                ? _c("p", [
                    _vm._v(
                      "\n        When you achieve 5 or more unconditional"
                    ),
                    _c("br"),
                    _vm._v(
                      "sale contracts in a\n        calendar month, UNIFI will reward you with a $5,000 bonus."
                    ),
                    _c("br"),
                    _c(
                      "span",
                      { staticStyle: { position: "relative", top: ".1rem" } },
                      [_vm._v("*Refer to FAQ page for payment terms")]
                    )
                  ])
                : _c("p", [
                    _vm._v(
                      "\n        You sold 5 houses this month and will now receive the $5,000 bonus!\n      "
                    )
                  ])
            ]
          ),
          _vm._v(" "),
          _c(
            "h1",
            {
              class: "tenant-" + _vm.tenant,
              staticStyle: { "margin-bottom": ".1rem" }
            },
            [_vm._v("\n      Commission to receive\n    ")]
          ),
          _vm._v(" "),
          _c("prevchart", {
            attrs: {
              barsHeight: _vm.barsHeight,
              date: _vm.date,
              price: _vm.ydata
            }
          }),
          _vm._v(" "),
          _c(
            "h1",
            {
              class: "tenant-" + _vm.tenant,
              staticStyle: { "margin-bottom": ".1rem" }
            },
            [_vm._v("\n      Financial year income\n    ")]
          ),
          _vm._v(" "),
          _c("nextchart", {
            attrs: {
              barsHeight: _vm.barsHeight2,
              date: _vm.date2,
              price: _vm.ydata2
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "list" }, [
            _c("ul", [
              _c(
                "li",
                { staticClass: "clear", class: { big: _vm.number > 0 } },
                [
                  _vm._v("\n          Invoices\n          "),
                  _c("button", { on: { click: _vm.toLst } }, [_vm._v("View")]),
                  _vm._v(" "),
                  _vm.number > 0
                    ? _c("div", { staticClass: "tip" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.number) +
                            " new due invoice\n          "
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("li", { staticClass: "clear" }, [
                _vm._v("\n          Bookmarked properties\n          "),
                _c("button", { on: { click: _vm.book } }, [_vm._v("View")])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "clear" }, [
                _vm._v("\n          Reserved properties\n          "),
                _c("button", { on: { click: _vm.reserve } }, [_vm._v("View")])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "clear" }, [
                _vm._v("\n          Purchased properties\n          "),
                _c("button", { on: { click: _vm.purchase } }, [_vm._v("View")])
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d2238eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2238eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/account.vue
// module id = null
// module chunks = 